/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { ChangeEvent, useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import {
  AutoComplete,
  Form,
  Input,
  Select,
  DatePicker,
  Space,
  Button,
  message,
  Tooltip,
} from "antd";
import {
  LoadingOutlined,
  SaveOutlined,
  ReloadOutlined,
  CloudUploadOutlined,
  CloudDownloadOutlined,
} from "@ant-design/icons";
import { RuleObject } from "antd/es/form";
import "../../../assets/scss/components/track/tageditor.scss";

import {
  getSearchTrackTitleList,
  getCountryList,
  getLanguages,
  getMoods,
  getRoles,
  getPublisher,
  getCopyRightP,
  getTrackPricingTier,
  savePublisher,
  saveCopyrightP,
} from "../../../actions/user";
import { Backend, Frontend } from "shared-types";
import { T_TrackMetadata } from "@type/global.types";
import PerformerWidget, { Performer } from "../edit-track/Performer";
import {
  Actions,
  filterOption,
  getSelectOptions,
  getSelectedOptions,
} from "../../../utils";
import dayjs, { Dayjs } from "dayjs";
import { defaultSelect, defaultTrackMetadata } from "./constants";
import * as Genre from "../../../actions/genre";
import { PublisherModal } from "../../modals/publisher";
import { CopyrightPModal } from "../../modals/copyright_p";
import { getCityList, getCopyrightP } from "../../../actions/suggest";
import { useDispatch } from "react-redux";
import { getCopyrightPOptionsFromApi, getLicensorOPtionsFromApi } from "../../../hooks/useOverlay";
import useAuth from "../../../hooks/useAuth";
import { RecordingCompanyModal } from "../../modals/recording_company";
import LicensorModel from "../../modals/licensor";

const { TextArea } = Input;

interface MetaDataFormProps {
  formData:
  | { type: "meta-data"; data: T_TrackMetadata }
  | { type: "post-data"; data: Frontend.T_TrackMetadataOutput };
  onSubmit?: (metaData: T_TrackMetadata) => void;
  disabled?: boolean;
  setFormData: (data: T_TrackMetadata) => void;
  onClickImport?: () => void;
  onClickExport?: (data: T_TrackMetadata) => void;
}

export enum TrackExportType {
  excel,
  xml,
}

const trackTypes = [
  {
    value: "Original",
    label: "Original",
  },
  {
    value: "Karaoke",
    label: "Karaoke",
  },
  {
    value: "Medley",
    label: "Medley",
  },
  {
    value: "Cover",
    label: "Cover",
  },
];

const yesNoSelect = [
  {
    value: 0,
    label: "Yes",
  },
  {
    value: 1,
    label: "No",
  },
];

function item<T = number>(
  item: Frontend.T_SelectItem<T> | undefined
): Frontend.T_SelectItem<T> | undefined {
  if (item === undefined) return undefined;
  else if (item.label === "" && (item.value === -1 || item.value === ""))
    return undefined;
  else return item;
}

export const MetadataForm: React.FC<MetaDataFormProps> = (
  props: MetaDataFormProps
) => {
  const [genreList, setGenreList] = useState<Backend.T_Genre[]>([]);
  const [moodList, setMoodList] = useState<Backend.T_Mood[]>([]);
  const [roleList, setRoleList] = useState<Backend.T_MemberRole[]>([]);
  const [languageList, setLanguageList] = useState<Backend.T_Language[]>([]);
  const [publisherList, setPublisherList] = useState<any[]>([]);
  const [priceTierList, setPriceTierList] = useState<any[]>([]);
  const [copyrightP, setCopyrightP] = useState<any[]>([]);
  const [copyrightC, setCopyrightC] = useState<any[]>([]);
  const [isLoading, setLoading] = useState(false);
  const [isSearchTitleLoading, setSearchTitleLoading] = useState(false);
  const [isFormDisable, setFormDisable] = useState<boolean>(true);
  const [trackTitleSearchList, setTrackTitleSearchList] = useState<
    Frontend.T_SelectItem[]
  >([]);
  const [countryList, setCountryList] = useState<Frontend.T_SelectItem[]>([]);
  const [companyList, setCompanyList] = useState<Frontend.T_SelectItem[]>([]);
  const [timer, setTimer] = useState<any>();
  const { formData, setFormData } = props;
  const [form] = Form.useForm();
  const [publisherModel, setpublisherModel] = useState<any>({});
  const [dynamicModel, setDynamicModel] = useState<any>({});
  const [showModals, setShowModals] = useState<any>({
    publisher: false,
    copyrightP: false,
    recordingCompany: false,
    licensor: false
  });
  const { user } = useAuth() as any;
  const dispatch = useDispatch();

  useEffect(() => {
    const main = async () => {
      const hide = message.loading("Loading form data. just a second...", 1000);
      setLoading(true);
      setFormDisable(true);
      let genreRes = await Genre.all();
      genreRes?.map((genre) => genreList.push(genre));
      setGenreList([...genreList]);
      let langRes = await getLanguages();
      langRes?.map((language) => languageList.push(language));
      setLanguageList([...languageList]);
      let publisherRes = await getPublisher();
      publisherRes?.map((publisher: any) => publisherList.push(publisher));
      setPublisherList([...publisherList]);

      let priceTierRes = await getTrackPricingTier();
      priceTierRes?.map((price: any) => priceTierList.push(price));
      setPriceTierList([...priceTierList]);

      let copyrightPRes = await getCopyrightP("");
      copyrightPRes.result.list?.map((copyright: any) =>
        copyrightP.push(copyright)
      );
      setCopyrightP([...copyrightP]);
      // let circleCRes = await getCopyrightP("");
      copyrightPRes.result.list?.map((copyright: any) =>
        copyrightC.push(copyright)
      );
      setCopyrightC([...copyrightC]);
      copyrightPRes.result.list?.map((copyright: any) =>
        companyList.push(copyright)
      );
      setCompanyList([...companyList]);
      const moodRes = await getMoods();
      moodRes.map((mood) => moodList.push(mood));
      setMoodList([...moodList]);
      let roleRes = await getRoles();
      roleRes.map((role) => roleList.push(role));
      setRoleList([...roleList]);
      await initCountryList();
      const hideLoading = () => {
        setLoading(false);
        setFormDisable(false);
      };
      setTimeout(hideLoading, 1000);
      hide();
    };
    main();
  }, []);

  const initCountryList = async () => {
    if (countryList.length < 10) {
      let response = (await getCountryList({})).countries;
      response?.map((item: any) => {
        return countryList.push({
          ...item,
          value: item.id,
          label: item.title,
        });
      });
      setCountryList([...countryList]);
    }
  };

  const getFormData = (
    data:
      | { type: "meta-data"; data: T_TrackMetadata }
      | { type: "post-data"; data: Frontend.T_TrackMetadataOutput }
  ) => {
    if (data.type === "meta-data") return data.data;
    else return getFormDataFromPostData(data.data);
  };

  const generateIsrc = () => {
    var randomNumbers = Math.floor(1000 + Math.random() * 9000);
    var year = getFormData(formData).yearOfPublication.year();
    return `DEB79${year}9${randomNumbers}`;
  };

  const getFormDataFromPostData = (
    postData: Frontend.T_TrackMetadataOutput
  ) => {
    let res: T_TrackMetadata = {
      ...defaultTrackMetadata,
      genre: defaultSelect.number,
      subGenre: defaultSelect.number,
      trackType: defaultSelect.string,
      titleLanguage: defaultSelect.number,
      mood: defaultSelect.number,
    };
    if (postData) {
      console.log("postData.genre_id", postData)
      let data = genreList.find((item) => item.id === postData?.genre_id);
      if (data && postData?.genre_id) {
        res.genre = {
          value: Number(postData.genre_id),
          label: data.title,
        };
      }

      data = genreList.find((item) => item.id === postData?.fileunder_id);
      if (data && postData?.genre_id) {
        res.subGenre = {
          value: postData.fileunder_id || 0,
          label: data.title,
        };
      }

      let langData = languageList.find(
        (item) => item.id === postData?.title_lang_id
      );
      if (langData && postData?.title_lang_id) {
        res.titleLanguage = {
          value: postData.title_lang_id,
          label: langData.title,
        };
      }
      langData = languageList.find((item) => item.id === postData.lyrics_lang_id);
      if (langData && postData?.lyrics_lang_id) {
        res.language = postData.lyrics_lang_id;
      }
      res.trackTitle = postData?.track_title;
      res.titleLanguage =
        languageList
          .map((item) => ({ label: item.title, value: item.id }))
          .find((item) => item.value === postData.title_lang_id) ||
        defaultSelect.number;
      res.trackPart = postData.track_part;
      res.startOfPreview = postData.start_of_preview;
      const tp = trackTypes.find((item) => item.value === postData.track_type);
      if (tp) res.trackType = tp;
      if (postData.publisher_id) res.publisher_id = postData.publisher_id;
      if (postData.price_code) res.priceCode = postData.price_code;
      if (postData.explicit_content)
        res.explicitContent = postData.explicit_content;
      if (postData.copyright_p) res.copyright_p = postData.copyright_p;
      if (postData.copyright_c) res.copyright_c = postData.copyright_c;
      if (postData.publication_date)
        res.yearOfPublication = dayjs(postData.publication_date);
      if (postData.catalogue_num) res.catalogue_num = postData.catalogue_num;
      if (postData.start_of_preview)
        res.startOfPreview = postData.start_of_preview;
      if (postData.release_date) res.releaseDate = dayjs(postData.release_date);
      if (postData.rec_date) res.rec_date = dayjs(postData.rec_date);
      if (postData.rec_country_id) res.rec_country_id = postData.rec_country_id;
      if (postData.rec_city) res.rec_city = postData.rec_city;
      if (postData.rec_company_id) res.rec_company_id = postData.rec_company_id;
      if (postData.licensor) res.licensor = postData.licensor;
      // if (
      //   postData.distribution_territories &&
      //   postData.distribution_territories.length
      // ) {
      //   let nData: Frontend.T_SelectItem[] = [];
      //   postData.distribution_territories.map((item) => {
      //     const f = countryList.find(
      //       (country) => Number(country.value) === Number(item)
      //     );
      //     if (f) nData.push(f);
      //   });
      //   res.distributionTerr = nData;
      // }
      if (postData.lyrics) res.lyrics = postData.lyrics;
      try {
        res.performers = [];
        postData.members?.map((member) => {
          res.performers.push({
            title: member.member_title,
            id: member.member_id,
            role: member.role_id,
            primary: member.primary,
          });
        });
      } catch (error) {
        res.performers = [];
      }
      if (postData.track_file != null) res.trackFile = postData.track_file;
      res.register_from = 2;
      if (postData.track_file_name != null)
        res.trackFileName = postData.track_file_name;
      if (postData.version != null) res.version = postData.version;
      const mood = moodList.find((item: any) => item.id === postData.mood_id);
      if (mood)
        res.mood = {
          value: mood.id,
          label: mood.title || "",
        };
      res.isrc = postData.isrc;
      res.source = postData.source;
      res.source_cd = postData.source_cd;
    }
    return res;
  };

  useEffect(() => {
    const data = getFormData(formData);
    form.setFieldsValue({
      ...data,
      priceCode: data.priceCode ? data.priceCode : "",
      titleLanguage:
        data.titleLanguage.value !== -1 ? data.titleLanguage : undefined,
      trackType: data.trackType?.value?.length ? data.trackType : undefined,
      genre: data.genre.value !== -1 ? data.genre : undefined,
      subGenre: data.subGenre.value !== -1 ? data.subGenre : undefined,
      mood: data?.mood?.value !== -1 ? data.mood : undefined,
    });
  }, [formData, isFormDisable]);

  const handleTrackTitleSearch = async (value: any) => {
    let res: any[] = [];
    if (value.length >= 2) {
      setSearchTitleLoading(true);
      let response = await getSearchTrackTitleList({
        keyword: value,
      });
      setSearchTitleLoading(false);
      let arr: any[] = [];
      for (let i = 0; i < response.length; i++) {
        const trackItem = response[i];
        if (arr.findIndex((item) => item.value === trackItem.value) < 0) {
          arr.push(trackItem);
        }
      }
      res = arr?.map((item: any, index: number) => {
        return {
          label: (
            <div key={index}>
              <b>{item.label.track_title}</b>
              {item.label.track_part ? (
                <span> / {item.label.track_part}</span>
              ) : (
                <span></span>
              )}
              <span> / {item.label.artist}</span>
              {item.label.genre_title ? (
                <span> / {item.label.genre_title}</span>
              ) : (
                <span></span>
              )}
              {item.label.clientTitle ? (
                <span style={{ color: "#0099FF" }}>
                  {" "}
                  / {item.label.clientTitle}
                </span>
              ) : (
                <span></span>
              )}
              <span> / {item.label.genre_title}</span>
            </div>
          ),
          value: item.value,
        };
      });
    }
    setTrackTitleSearchList(res);
  };

  function performerValidator(
    rule: RuleObject,
    value: Performer[] | undefined,
    callback: (error?: string | undefined) => void
  ): void | Promise<any> {
    if (value?.filter((item) => item.id > -1 && item.role > -1).length) {
      let nComposer = value.filter((item) => item.role === 13).length;
      let nPerformer = value.filter((item) => item.role === 43).length;
      if (nComposer > 0) {
        if (nPerformer > 0) return callback();
        else callback("Please select at lease one performer role");
      } else callback("Please select at lease one composer role");
      if (formData.type === "meta-data") {
        console.log(formData.data.performers);
      }
    } else callback("Please add performer and role");
  }

  /*********************   Form change event handlers start *********************/

  const onSearchTrackTitle = (e: string) => {
    clearTimeout(timer);
    setTimer(setTimeout(() => handleTrackTitleSearch(e), 500));
  };

  const onChangeTrackTitle = (value: string) => {
    const data = getFormData(formData);
    setFormData({
      ...data,
      trackTitle: value,
    });
  };

  const onChangeLanguage = (_: any, val: Frontend.T_SelectItem) => {
    setFormData({ ...getFormData(formData), titleLanguage: val });
  };

  const onChangeGenre = (_: any, val: Frontend.T_SelectItem) => {
    setFormData({ ...getFormData(formData), genre: val });
  };

  const onChangeSubGenre = (_: any, val: Frontend.T_SelectItem) => {
    setFormData({ ...getFormData(formData), subGenre: val });
  };

  const onChangeMood = (_: any, val: Frontend.T_SelectItem) => {
    setFormData({ ...getFormData(formData), mood: val });
  };

  const onChangeTractPart: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setFormData({ ...getFormData(formData), trackPart: e.target.value });
  };

  const onChangeTrackType = (_: any, option: Frontend.T_SelectItem<string>) => {
    setFormData({ ...getFormData(formData), trackType: option });
  };

  function onChangeInstrumental(value: any) {
    setFormData({ ...getFormData(formData), instPossibleVal: value });
  }

  const onChangePublisher = (_: any, val: any) => {
    setFormData({ ...getFormData(formData), publisher_id: val.value });
  };

  const onChangeLicensor = (action: any, val: any) => {
    setFormData({ ...getFormData(formData), licensor: action });
  };

  const onChangePriceCode = (_: any, val: any) => {
    setFormData({ ...getFormData(formData), priceCode: val });
  };

  function onChangePublicationDate(value: Dayjs | null): void {
    if (value !== null)
      setFormData({ ...getFormData(formData), yearOfPublication: value });
  }

  function onChangeCatalogue(event: ChangeEvent<HTMLInputElement>): void {
    setFormData({
      ...getFormData(formData),
      catalogue_num: event.target.value,
    });
  }

  function onChangeSource(event: ChangeEvent<HTMLInputElement>): void {
    setFormData({ ...getFormData(formData), source: event.target.value });
  }

  function onChangeSourceCD(event: ChangeEvent<HTMLInputElement>): void {
    setFormData({ ...getFormData(formData), source_cd: event.target.value });
  }

  function onChangeExplicitContent(value: number) {
    setFormData({ ...getFormData(formData), explicitContent: value });
  }

  function onChangeISRC(event: ChangeEvent<HTMLInputElement>): void {
    setFormData({ ...getFormData(formData), isrc: event.target.value });
  }

  async function onClickGenerateISRC() {
    const isrc = generateIsrc();
    form.setFieldsValue({
      isrc,
    });
    setFormData({
      ...getFormData(formData),
      isrc,
    });
  }

  function onChangeCopyrightP(value: any) {
    setFormData({ ...getFormData(formData), copyright_p: value.value });
  }

  function onChangeCircleC(value: any) {
    setFormData({ ...getFormData(formData), copyright_c: value });
  }

  function onChangeRecordingCountry(value: any) {
    setFormData({ ...getFormData(formData), rec_country_id: value });
  }

  function onChangeRecordingCity(event: ChangeEvent<HTMLInputElement>): void {
    setFormData({ ...getFormData(formData), rec_city: event.target.value });
  }

  function onChangeRecordingCompany(value: any) {
    setFormData({ ...getFormData(formData), rec_company_id: value });
  }

  function onChangeStartOfPreview(event: ChangeEvent<HTMLInputElement>): void {
    setFormData({
      ...getFormData(formData),
      startOfPreview: Number(event.target.value),
    });
  }

  function onChangeReleaseDate(value: Dayjs | null): void {
    if (value !== null)
      setFormData({ ...getFormData(formData), releaseDate: value });
  }

  function onChangeRecordingDate(value: Dayjs | null): void {
    if (value !== null)
      setFormData({ ...getFormData(formData), rec_date: value });
  }

  function onChangeVersion(event: ChangeEvent<HTMLInputElement>): void {
    setFormData({ ...getFormData(formData), version: event.target.value });
  }

  function onChangeLyricsLanguage(value: number) {
    setFormData({ ...getFormData(formData), language: value });
  }

  // function onChangeDistributionTerr(
  //   _value: Frontend.T_SelectItem<number>[],
  //   option: Frontend.T_SelectItem<number> | Frontend.T_SelectItem<number>[]
  // ): void {
  //   if (option instanceof Array)
  //     setFormData({ ...getFormData(formData), distributionTerr: option });
  //   else setFormData({ ...getFormData(formData), distributionTerr: [option] });
  // }

  function onChangeLyrics(event: ChangeEvent<HTMLTextAreaElement>): void {
    setFormData({ ...getFormData(formData), lyrics: event.target.value });
  }

  function onChangePerformer(performers: Performer[]) {
    setFormData({ ...getFormData(formData), performers: [...performers] });
  }

  async function onFormSubmit(event: React.FormEvent<HTMLFormElement>) {
    if (props.onSubmit) {
      props?.onSubmit(getFormData(formData));
    }
  }

  function onClickXMLExport() {
    if (props.onClickExport) props.onClickExport(getFormData(formData));
  }

  /*********************   Form change event handlers end   *********************/

  const handlePublisherAddAction = () => {
    setpublisherModel({
      id: 0,
      validate: true,
      title: "",
      dba: "",
      parent_id: !user.company ? 2 : user.company,
      level: 2,
      country_id: undefined,
      state: "",
      city: "",
      addr: "",
      url: "",
      zip_code: "",
      tel: "",
      fax: "",
      email: "",
      register_from: !user.company ? 2 : user.company,
      action: Actions.add,
      message: "",
    });
    setShowModals({ ...showModals, publisher: true });
  };

  const handleAddAction = (entityType: string) => {
    setDynamicModel({
      id: 0,
      validate: true,
      title: "",
      dba: "",
      parent_id: !user.company ? 2 : user.company,
      level: 2,
      country_id: undefined,
      state: "",
      city: "",
      addr: "",
      url: "",
      zip_code: "",
      tel: "",
      fax: "",
      email: "",
      register_from: !user.company ? 2 : user.company,
      action: Actions.add,
      message: "",
    });
    if (entityType === "recordingCompany") {
      setShowModals({ ...showModals, recordingCompany: true });
    } else if (entityType === "copyrightP") {
      setShowModals({ ...showModals, copyrightP: true });
    } else if (entityType === "licensor") {
      setShowModals({ ...showModals, licensor: true });
    }

  };

  const handleDynamicSaveAction = async (event: {
    currentTarget: any;
    preventDefault: () => void;
    stopPropagation: () => void;
  }) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity() === false) {
      setDynamicModel({ ...dynamicModel, validate: false, message: "" });
    } else {
      setDynamicModel({ ...dynamicModel, validate: true, message: "" });
      saveCopyrightP({
        ...dynamicModel,
        action: "add",
      }).then((res: any) => {
        if (res.result.status) {
          setDynamicModel({
            ...dynamicModel,
            message: res.result.message,
            validate: true,
          });
        } else {
          if (dynamicModel.action === Actions.add) {
            dispatch({
              type: "SET_ADDED_STATUS",
              payload: "copyrightP",
            });
          }
          handleCloseModal()
        }

      });
    }
  };


  const handlePublisherSaveAction = async (event: {
    currentTarget: any;
    preventDefault: () => void;
    stopPropagation: () => void;
  }) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity() === false) {
      setpublisherModel({ ...publisherModel, validate: false, message: "" });
    } else {
      setpublisherModel({ ...publisherModel, validate: true, message: "" });
      savePublisher({
        ...publisherModel,
        action: "add",
      }).then((res: any) => {
        if (res.result.status) {
          setpublisherModel({
            ...publisherModel,
            message: res.result.message,
            validate: true,
          });
        } else {
          if (publisherModel.action === Actions.add) {
            dispatch({
              type: "SET_ADDED_STATUS",
              payload: "publisher",
            });
          }
          setShowModals({ ...showModals, publisher: false });
        }
      });
    }
  };

  const handleCloseModal = () => {
    setShowModals({
      publisher: false,
      copyrightP: false,
      recordingCompany: false,
      licensor: false
    });
  };


  function debounce(func: Function, delay: number) {
    let timeoutId: NodeJS.Timeout;
    return function debounced(...args: any[]) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }

  return (
    <div className="page-tageditor">
      <div className="tw-py-3 tw-text-right tw-space-x-3">
        {props.onClickImport !== undefined ? (
          <Button
            type="primary"
            icon={<CloudUploadOutlined />}
            onClick={props.onClickImport}
            disabled={props.disabled || isLoading}
          >
            Upload XML
          </Button>
        ) : (
          ""
        )}
        {props.onClickExport !== undefined ? (
          <Button
            type="primary"
            icon={<CloudDownloadOutlined />}
            onClick={onClickXMLExport}
          // disabled={props.disabled || isLoading}
          >
            Export XML
          </Button>
        ) : (
          ""
        )}
      </div>
      <Form
        name="track-edit-form"
        labelCol={{ span: 12 }}
        onFinish={onFormSubmit}
        layout="vertical"
        className="tw-grid tw-gap-4 tw-grid-cols-12 tw-py-8 track-meta-form"
        size="large"
        form={form}
        initialValues={formData}
      // disabled={props.disabled || isLoading}
      >
        <Form.Item
          label="Title"
          name="trackTitle"
          rules={[
            {
              required: true,
              message: "Please input track title",
            },
          ]}
          className="tw-col-span-12"
        >
          <AutoComplete
            onSearch={onSearchTrackTitle}
            onChange={onChangeTrackTitle}
            onSelect={onChangeTrackTitle}
            options={isLoading ? [] : trackTitleSearchList}
            value={getFormData(formData).trackTitle}
            placeholder="Search keyword"
            notFoundContent={
              isSearchTitleLoading ? <LoadingOutlined rev={undefined} /> : ""
            }
          />
        </Form.Item>
        <Form.Item
          label="Metadata Language"
          name="titleLanguage"
          rules={[
            {
              required: true,
              message: "Please select language",
            },
          ]}
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <Select
            options={getSelectOptions(languageList)}
            showSearch
            filterOption={filterOption}
            placeholder="Please select Metadata Language"
            value={item(getFormData(formData).titleLanguage)}
            onSelect={onChangeLanguage}
            maxLength={1}
          />
        </Form.Item>
        <Form.Item
          label="Track Part"
          name="trackPart"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <Input
            onChange={onChangeTractPart}
            value={getFormData(formData).trackPart}
            placeholder="Please enter Track Part"
          />
        </Form.Item>
        <Form.Item
          label="Track Types"
          name="trackType"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <Select
            options={trackTypes}
            showSearch
            filterOption={filterOption}
            value={item(getFormData(formData).trackType)}
            placeholder="Please select Track Type"
            onSelect={onChangeTrackType}
          ></Select>
        </Form.Item>
        <Form.Item
          label="Genre"
          name="genre"
          rules={[
            {
              required: true,
              message: "Please select genre",
            },
          ]}
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <Select
            options={getSelectOptions(
              genreList.filter(
                (genre) =>
                  genre.parent_id === 0 &&
                  genreList.find((item) => item.parent_id === genre.id)
              )
            )}
            showSearch
            filterOption={filterOption}
            onSelect={onChangeGenre}
            value={item(getFormData(formData).genre)}
            placeholder="Please select Genre"
          />
        </Form.Item>
        <Form.Item
          label="Sub Genre"
          name="subGenre"
          rules={[
            {
              required: true,
              message: "Please select sub genre",
            },
          ]}
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <Select
            options={getSelectOptions(
              getFormData(formData).genre.value === 0
                ? []
                : genreList.filter(
                  (genre) =>
                    genre.parent_id === getFormData(formData).genre.value
                )
            )}
            showSearch
            filterOption={filterOption}
            onSelect={onChangeSubGenre}
            value={getFormData(formData).subGenre}
            placeholder="Please select Sub Genre"
          />
        </Form.Item>
        <Form.Item
          label="Mood"
          name="mood"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <Select
            options={getSelectOptions(moodList)}
            showSearch
            filterOption={filterOption}
            onSelect={onChangeMood}
            value={item(getFormData(formData).mood)}
            placeholder="Please select Mood"
          />
        </Form.Item>
        <Form.Item
          label="Instrumental"
          name="instPossibleVal"
          rules={[
            {
              required: true,
              message: "Please select instrumental",
            },
          ]}
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <Select
            options={yesNoSelect}
            onChange={onChangeInstrumental}
            value={getFormData(formData).instPossibleVal}
            placeholder="Please select Instrumental"
          />
        </Form.Item>
        <Form.Item
          label={
            <>
              Licensor (
              <a
                className="text-purple-600 underline underline-click-event"
                onClick={() => handleAddAction("licensor")}
              >
                Add New
              </a>
              )
            </>
          }
          name="licensor"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <AsyncSelect
            className={"select-search basic-single"}
            classNamePrefix="select"
            loadOptions={debounce(getLicensorOPtionsFromApi, 500)}
            placeholder="Please select Licensor"
            isMulti={false}
            value={getFormData(formData).licensor}
            onChange={onChangeLicensor}
            isSearchable={true}
          />
        </Form.Item>
        <Form.Item
          label={
            <>
              Publisher (
              <a
                className="text-purple-600 underline underline-click-event"
                onClick={() => handlePublisherAddAction()}
              >
                Add New
              </a>
              )
            </>
          }
          name="publisher"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <Select
            options={getSelectedOptions(publisherList)}
            placeholder="Please add/select Publisher"
            showSearch
            filterOption={filterOption}
            value={getFormData(formData).publisher_id}
            onSelect={onChangePublisher}
            maxLength={1}
          />
        </Form.Item>
        <Form.Item
          label="Year of Publication"
          name="yearOfPublication"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
          rules={[
            {
              required: true,
              message: "Please input year of publication",
            },
          ]}
        >
          <DatePicker
            className="tw-w-full"
            onChange={onChangePublicationDate}
            value={dayjs(getFormData(formData).yearOfPublication)}
            format={"DD-MM-YYYY"}
          />
        </Form.Item>
        <Form.Item
          label="Pricing Tier"
          name="priceCode"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <Select
            options={getSelectOptions(priceTierList)}
            showSearch
            filterOption={filterOption}
            value={getFormData(formData).priceCode}
            onSelect={onChangePriceCode}
            maxLength={1}
            placeholder="Please select Pricing Tier"
          />
        </Form.Item>
        <Form.Item
          label="Catalogue Number"
          name="catalogue_num"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <Input
            value={getFormData(formData).catalogue_num}
            onChange={onChangeCatalogue}
            placeholder="Please enter Catalogue Number"
          />
        </Form.Item>
        <Form.Item
          label="Explicit Content"
          name="explicitContent"
          rules={[
            {
              required: true,
              message: "Please select explicit content",
            },
          ]}
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <Select
            options={yesNoSelect}
            value={getFormData(formData).explicitContent}
            onChange={onChangeExplicitContent}
            placeholder="Please select Explicit Content"
          />
        </Form.Item>
        <Form.Item
          label="ISRC"
          name="isrc"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
          validateTrigger={["onChange", "onBlur"]}
        >
          <Space.Compact className="tw-w-full" size="large">
            <Input value={getFormData(formData).isrc} onChange={onChangeISRC} />
            <Button
              className="tw-w-[40px] ant-input-compact-second-item"
              onClick={onClickGenerateISRC}
              icon={
                <ReloadOutlined
                  rev={undefined}
                  className="tw-text-blue-600 !tw-inline-flex"
                />
              }
            ></Button>
          </Space.Compact>
        </Form.Item>
        <Form.Item
          label={
            <>
              Copyright P (
              <a
                className="text-purple-600 underline underline-click-event"
                onClick={() => handleAddAction("copyrightP")}
              >
                Add New
              </a>
              )
            </>
          }
          name="copyrightP"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >

          <AsyncSelect
            className="select-search basic-single"
            classNamePrefix="select"
            loadOptions={debounce(getCopyrightPOptionsFromApi, 500)}
            placeholder="Please add/select Copyright P"
            isMulti={false}
            value={getFormData(formData).copyright_p}
            onChange={onChangeCopyrightP}
            isSearchable={true}
          />
        </Form.Item>
        <Form.Item
          label={"Copyright C"}
          name="copyright_c"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <Select
            options={getSelectedOptions(copyrightC)}
            showSearch
            filterOption={filterOption}
            value={getFormData(formData).copyright_c}
            onSelect={onChangeCircleC}
            maxLength={1}
            placeholder="Please select Copyright C"
          />
        </Form.Item>
        <Form.Item
          label="Start of Preview"
          name="startOfPreview"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <Tooltip
            placement="top"
            title="Specifies the starting point of a 30-second preview on stores, in seconds"
            trigger="hover"
          >
            <Input
              value={getFormData(formData).startOfPreview}
              onChange={onChangeStartOfPreview}
              type="number"
              placeholder="Please enter Start of Preview"
            />
          </Tooltip>
        </Form.Item>
        <Form.Item
          label="Release Date"
          name="releaseDate"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <DatePicker
            className="tw-w-full"
            onChange={onChangeReleaseDate}
            value={dayjs(getFormData(formData).releaseDate, "YYYY-MM-DD")}
            format={"DD.MM.YYYY"}
          />
        </Form.Item>
        <Form.Item
          label="Recording Date"
          name="rec_date"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          {/* <DatePicker
            className="tw-w-full"
            onChange={onChangeRecordingDate}
            value={dayjs(getFormData(formData).rec_date)}
            format={"DD.MM.YYYY"}
          /> */}
        </Form.Item>
        <Form.Item
          label="Recording Country"
          name="rec_country_id"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <Select
            options={getSelectedOptions(countryList)}
            showSearch
            filterOption={filterOption}
            value={getFormData(formData).rec_country_id}
            onSelect={onChangeRecordingCountry}
            maxLength={1}
            placeholder="Please select Recording Country"
          />
        </Form.Item>
        <Form.Item
          label="Recording City"
          name="rec_city"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <Input
            value={getFormData(formData).rec_city}
            onChange={onChangeRecordingCity}
            placeholder="Please select Recording City"
          />
        </Form.Item>
        <Form.Item
          label={
            <>
              Recording Company (
              <a
                className="text-purple-600 underline underline-click-event"
                onClick={() => handleAddAction("recordingCompany")}
              >
                Add New
              </a>
              )
            </>
          }
          name="rec_company_id"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <Select
            options={getSelectedOptions(companyList)}
            showSearch
            filterOption={filterOption}
            value={getFormData(formData).rec_company_id}
            onSelect={onChangeRecordingCompany}
            maxLength={1}
            placeholder="Please select Recording Company"
          />
        </Form.Item>
        <Form.Item
          label="Version"
          name="version"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <Input
            value={getFormData(formData).version}
            onChange={onChangeVersion}
            placeholder="Please enter Version"
          />
        </Form.Item>
        <Form.Item
          label="Lyrics Language"
          name="language"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
          rules={[
            {
              required: true,
              message: "Please select Language",
            },
          ]}
        >
          <Select
            options={getSelectOptions(languageList)}
            showSearch
            filterOption={filterOption}
            value={getFormData(formData).language}
            onChange={onChangeLyricsLanguage}
            placeholder="Please select Language"
          />
        </Form.Item>
        <Form.Item
          label="Source CD"
          name="source_cd"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <Input
            value={getFormData(formData).source_cd}
            onChange={onChangeSourceCD}
            placeholder="Please enter Source CD"
          />
        </Form.Item>
        <Form.Item
          label="Source"
          name="source"
          className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
        >
          <Input
            value={getFormData(formData).source}
            onChange={onChangeSource}
            placeholder="Please enter Source"
          />
        </Form.Item>
        {/* <Form.Item
          label="Distribution territories"
          name="distributionTerr"
          className="tw-col-span-12"
        >
          <Select
            options={countryList}
            showSearch
            filterOption={filterOption}
            tokenSeparators={[","]}
            mode="tags"
            value={getFormData(formData).distributionTerr}
            onChange={onChangeDistributionTerr}
            placeholder="Please select Distribution territories"
          />
        </Form.Item> */}
        <Form.Item
          label="Lyrics"
          name="lyrics"
          className="tw-col-span-12 md:tw-col-span-6"
        >
          <TextArea
            rows={4}
            value={getFormData(formData).lyrics}
            onChange={onChangeLyrics}
            placeholder="Please enter Lyrics"
          />
        </Form.Item>
        <Form.Item
          label="Performers"
          name="performers"
          rules={[
            {
              validator: performerValidator,
              required: true,
            },
          ]}
          className="tw-col-span-12 md:tw-col-span-6"
        >
          <PerformerWidget
            roles={roleList}
            onChange={onChangePerformer}
            performers={getFormData(formData).performers}
            className={`tw-bg-white tw-rounded-md tw-min-h-[116px] ant-input css-dev-only-do-not-override-ixblex tw-py-2 tw-px-3`}
            disabled={isFormDisable || props.disabled}
          />
        </Form.Item>
        <Form.Item className="tw-col-span-12 tw-text-center">
          <Button
            type="primary"
            htmlType="submit"
            className="!tw-rounded-full"
            icon={<SaveOutlined rev={undefined} className="!tw-inline-flex" />}
          >
            Save
          </Button>
        </Form.Item>

        <PublisherModal
          mkey={"publisher-add"}
          show={showModals.publisher}
          model={publisherModel}
          setModel={setpublisherModel}
          closeModal={handleCloseModal}
          saveModal={handlePublisherSaveAction}
        />
        <CopyrightPModal
          mkey={"copyrightP-add"}
          show={showModals.copyrightP}
          model={dynamicModel}
          setModel={setDynamicModel}
          closeModal={handleCloseModal}
          saveModal={handleDynamicSaveAction}
        />

        <RecordingCompanyModal
          mkey={"recordingCompany-add"}
          show={showModals.recordingCompany}
          model={dynamicModel}
          setModel={setDynamicModel}
          closeModal={handleCloseModal}
          saveModal={handleDynamicSaveAction}
        />

        <LicensorModel
          mkey={"licensor-add"}
          show={showModals.licensor}
          model={dynamicModel}
          setModel={setDynamicModel}
          closeModal={handleCloseModal}
          saveModal={handleDynamicSaveAction}
          countryList={countryList}
        />
      </Form>
    </div>
  );
};
